<div *ngIf="!showCart" class="filter-section">
  <div class="date-filters">
    <label>
      Start Date:
      <input type="date" [(ngModel)]="startDate" />
    </label>

    <label>
      End Date:
      <input type="date" [(ngModel)]="endDate" />
    </label>
  </div>

  <div class="filter-buttons">
    <button mat-raised-button color="primary" (click)="page = 1; fetchLoads()">Apply Filter</button>
  </div>
</div>

<mat-card class="order-list-card" *ngIf="!showCart && loads.length > 0">
  <h3 class="card-title">Filtered Loads</h3>
  <app-load-table *ngIf="!showCart && loads.length > 0"
                  [isDraggable]="false"
                  [loads]="loads"
                  (loadSelected)="viewLoadDetails($event)">
  </app-load-table>

  <div class="pagination-controls">
    <button mat-button (click)="prevPage()" [disabled]="page === 1">Previous</button>
    <span>Page {{ page }} of {{ totalPages }}</span>
    <button mat-button (click)="nextPage()" [disabled]="page === totalPages">Next</button>
  </div>
</mat-card>

<div *ngIf="showCart">
  <app-load-viewer [load]="selectedLoad" (reloadDetails) = "onReloadDetails()"  (closedLoadDetails)="showCart = false"></app-load-viewer>
</div>
